module.exports = __webpack_public_path__ + "img/partner_mo.a12f613a.png";